import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardListIcon, TruckIcon, FlowerIcon, RefreshCwIcon } from 'lucide-react';
export function HowItWorks() {
  return <section id="how-it-works" className="py-16 bg-white" data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-247">
            How Sunton Florist Works
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-248">
            We've simplified the process of keeping your space beautiful with
            fresh flowers and plants
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-249">
          <div className="flex flex-col items-center text-center" data-id="element-250">
            <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-251">
              <ClipboardListIcon className="h-8 w-8 text-pink-700" data-id="element-252" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-253">
              1. Choose Your Plan
            </h3>
            <p className="text-gray-600" data-id="element-254">
              Select from our weekly, bi-weekly, or monthly subscription options
              based on your needs.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-255">
            <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-256">
              <FlowerIcon className="h-8 w-8 text-pink-700" data-id="element-257" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-258">
              2. Customize Your Blooms
            </h3>
            <p className="text-gray-600" data-id="element-259">
              Choose your preferred flower types, colors, and add special notes
              for recipients.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-260">
            <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-261">
              <TruckIcon className="h-8 w-8 text-pink-700" data-id="element-262" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-263">
              3. We Deliver
            </h3>
            <p className="text-gray-600" data-id="element-264">
              Our team carefully arranges and delivers your flowers right to
              your doorstep.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-265">
            <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-266">
              <RefreshCwIcon className="h-8 w-8 text-pink-700" data-id="element-267" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-268">
              4. Enjoy & Repeat
            </h3>
            <p className="text-gray-600" data-id="element-269">
              Enjoy your fresh blooms and we'll automatically deliver your next
              arrangement on schedule.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-270">
          <Link to="/how-it-works" className="px-8 py-3 bg-pink-700 text-white rounded-md text-lg font-medium hover:bg-pink-800 transition-colors" data-id="element-271">
            Get Started Now
          </Link>
        </div>
      </div>
    </section>;
}